import { requestsClient } from '@/shared/api';

import { ECompanyAdditionalInfoKeys } from '../enums';

export const personalQuery = async () => {
  const { myPersonalData } = await requestsClient.myPersonalData({
    addressesInput: { pagination: {} },
  });
  return myPersonalData;
};

export const companiesQuery = async () => {
  const { myCompanies } = await requestsClient.myCompanies({
    input: { pagination: { limit: 1 } },
    additionalInfosInput: {
      pagination: {},
      keys: [ECompanyAdditionalInfoKeys.CompanyOnboardingStep],
    },
  });

  return myCompanies;
};
